<template>
    <v-row v-if="$rc.inIndustry('wine')" class="my-1">
        <v-col cols="12">
            <v-alert
                type="error"
                class="shaded-light"
                border="left"
                colored-border
            >
                <div>
                    <slot name="title">
                        <strong>Carrier Update</strong>
                        
                        
                        <p
                            style="margin-top: 5px"
                        >
                            During the December holidays, we were notified of unusual carrier blocks affecting three wineries in rapid succession. 
                            All originated from a single aggregator in the messaging ecosystem. When a winery is blocked, all of that winery's messaging
                            through that aggregator is suspended until resolved — not just promotional messages — which can interrupt other important communications.
                        </p>

                        <p>
                            <b>Current status:</b> All three wineries are fully unblocked, and their messaging is back to normal. We have not seen any additional blocks since December 22nd.
                        </p>

                        <p>
                            <b>What to do now:</b>
                            <ul>
                                <li>If you're concerned about experiencing a disruptive block, consider using indirect promotional language.</li>
                                <li>Watch for an upcoming RedChirp prompt to begin toll-free number registration, which can provide an alternative messaging path. The sooner you complete it, the sooner we can submit your registration for review.</li>
                            </ul>
                        </p>

                        <a href="https://redchirp.com/emerging-carrier-issue-updates-week-of-jan-12th/" target="_blank">Read the full update here.</a>

                    </slot>
                </div>
            </v-alert>
        </v-col>
    </v-row>
</template>

<script>
/*import WineryCarrierAlertContent from '@/components/bulk/winery-carrier-alert-content.vue';*/

export default {
    name: 'TempDisableWineriesFromScheduling',

    /*components: {
        WineryCarrierAlertContent,
    },*/

    data() {
        return {
            show_details: false,
        };
    },
};
</script>

<style lang="scss" scoped>
a {
    color: var(--v-primary-base) !important;
    text-decoration: none;
}
</style>